import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IProps {
  dragging?: boolean;
  zIndexValue?: string;
  positionValue?: string;
  opacityValue?: string;
  widthValue?: string;
  isOver?:boolean;
}

export const Root = styled.div`
`;

export const GalleryPanelContainer = styled.div`
`

export const GalleryMessage = styled.div`
  padding: 32px 22px 10px 19px;
  font-family: Roboto;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: left;
  color: #000;
`

export const GalleryButtonsContainer = styled.div`
  display: flex;
  padding: 19px;
  justify-content: space-between;
`
export const GalleryDropDownContainer = styled.div`
  display: flex;
  padding: 19px;  
`

export const PanelContainer = styled.div`
`

export const ButtonPanel = styled.div`
  padding: 27px 18px;
`

export const ButtonContainer = styled.div`
  display: flex;
  border-radius: 5px;
  background-color: ${C.DARK_BLUE};
`

export const ButtonDivider = styled.div`
  width: 1px;
  height: 36px;
  background-color: ${C.WHITE};
`

export const ButtonOptionsIcon = styled.div`
  width: 38px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 5px;
  &:hover {
    background-color: #344a70;
  }
`

export const ButtonOptionsIconScale = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  transform: scale(0.7);
`

export const ButtonOptionsContainer = styled.div`
  position: absolute;
  padding: 9px 0px;
  width: 227px;
  top: 68px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 3px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16);
  background-color: ${C.WHITE};
  z-index: 5;
`

export const ButtonOption = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 11px 14px;
  font-family: Roboto;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  cursor: pointer;
  color: ${C.BLACK};
  &:hover {
    background-color: rgba(32, 64, 120, 0.05);
  }
`

export const DnDContainer = styled.div`
  padding: 14px 18px;
`

export const DndBox = styled.div`
  width: 100%;
  height: 180px;
  padding: 0px 28px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12);
  border: solid 1px #c4c4c4;
  border-radius: 10px;
  ${(props: IProps) => props.dragging ? 'border: 2px solid #ff7319;' : ''}
  background-color: ${(props:IProps) => props.dragging ? '#fffaf6' : '#ffffff'};
  margin-top: 16px;
  margin-bottom: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  box-sizing: border-box;
`;

export const DnDText = styled.span`
  font-family: Roboto;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: rgba(112, 112, 112, 0.5);
`

export const ListComponentContainer = styled.div`
  position: relative;
`

export const ReplaceMessage = styled.div`
  padding: 22px 22px 0px 19px;
  font-family: Roboto;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: rgba(18, 36, 66, 0.6);
`

export const ListContainer = styled.div`
  margin: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  overflow-x: hidden;
  box-sizing: border-box;
  overflow: hidden;
`

export const DragImageContainer = styled.div`
  cursor: pointer;
  position: relative;
`;

export const ListComponent = styled.img`
  object-fit: contain;
  padding: 5px;
  cursor: pointer;
  position: ${(props: IProps) => (props.positionValue ?? 'auto')};
  opacity: ${(props: IProps) => (props.opacityValue ?? '1')};
  z-index: ${(props: IProps) => (props.zIndexValue ?? 'auto')};
`

export const ProgressContainer = styled.div`
  position: absolute;
  bottom: 15px;
  display: flex;
  width: ${(props: IProps) => (props.widthValue ?? 'auto')};
  justify-content: center;
  z-index: 1;
`


export const TrashButton = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  flex-grow: 0;
  padding: 5px 8px 4px 7px;
  border-radius: 5px;
  background-color: rgba(32, 64, 120, 0.7);
  
`
export const CheckboxContainer = styled.div`
  position: absolute;
  top: 8px;
  left: 8px;
  background: white;
  padding: 3px;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;

  input {
    appearance: none;
    width: 18px;
    height: 18px;
    border-radius: 4px;
    border: 2px solid ${C.GRAY};
    background-color: ${C.WHITE};
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease-in-out;
  }

  input:checked {
    background-color: ${C.DARK_BLUE};
    border-color: ${C.DARK_BLUE};
  }

  input:checked::before {
    content: "✔";
    color: ${C.WHITE};
    font-size: 14px;
    font-weight: bold;
    position: relative;
    top: -1px;
  }

  &:hover {
    background-color: rgba(0, 123, 255, 0.1);
  }
`;

export const DeleteButton = styled.button`
  width: 90%;
  max-width: 220px;
  padding: 12px 16px;
  background-color: ${C.DARK_BLUE};
  color: ${C.WHITE};
  font-size: 12px;
  font-weight: bold;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  display: block;
  margin: 20px auto;

  &:hover {
    background-color: #344a70;
  }

  &:disabled {
    background-color: ${C.GRAY};
    cursor: not-allowed;
  }
`;



export const SelectAllContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 10px 0;
  padding-right: 10px;
  font-size: 14px;
  color: ${C.LIGHT_GRAY}; /* Color gris claro */
  cursor: pointer;
  user-select: none;

  input {
    margin-left: 8px;
    appearance: none;
    width: 18px;
    height: 18px;
    border-radius: 4px;
    border: 2px solid ${C.GRAY};
    background-color: ${C.WHITE};
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease-in-out;
  }

  input:checked {
    background-color: ${C.DARK_BLUE};
    border-color: ${C.DARK_BLUE};
  }

  input:checked::before {
    content: "✔";
    color: ${C.WHITE};
    font-size: 14px;
    font-weight: bold;
    position: relative;
    top: -1px;
  }
`;
